import { useState } from "react";
import FileInput from "../../Components/FileInput/FileInput";
import Button from "../../Components/Button";
import Loading from "../../Components/Loading/Loading";
import {
  addBulkInstrument,
  deleteBulkInstrument,
} from "../../Requests/insSettingRequests";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

const BulkAddDeleteInstrument = () => {
  const [excelFile, setExcelFile] = useState<FormData | null>(null);
  const [loading, setLoading] = useState(false);

  const addInsClickHandler = () => {
    if (!excelFile) return;
    setLoading(true);
    addBulkInstrument(excelFile)
      .then((resp) => {
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  const deleteInsClickHandler = () => {
    if (!excelFile) return;
    setLoading(true);
    deleteBulkInstrument(excelFile)
      .then((resp) => {
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="border-2 border-gray-300 flex flex-col justify-start items-center gap-3 w-80 p-2 rounded-md">
      <h2>اضافه کردن دسته ای نماد</h2>
      <FileInput
        fileExtension=".xlsx, .xls, .csv"
        UI={<></>}
        onChange={setExcelFile}
        value={excelFile}
        name="formFile"
        label="انتخاب فایل اکسل"
      />
      <Button
        text={
          loading ? <Loading size={20} className="!text-white" /> : "اضافه کردن"
        }
        variant="contained"
        onClick={addInsClickHandler}
        disabled={!!!excelFile}
      />
      <Button
        text={loading ? <Loading size={20} className="!text-white" /> : "حذف"}
        variant="contained"
        onClick={deleteInsClickHandler}
        className={excelFile ? "red-btn" : ""}
        disabled={!excelFile}
      />
    </div>
  );
};

export default BulkAddDeleteInstrument;
